import { CoreWorker as WorkerCachemap } from '@cachemap/core-worker';
import { type LogLevel, type PlainObject } from '@graphql-box/core';
import { DebugManager } from '@graphql-box/debug-manager';
// import { FetchManager } from '@graphql-box/fetch-manager';
import { WorkerClient } from '@graphql-box/worker-client';

// const { NODE_ENV } = process.env;

export const createWorkerClient = () => {
  // const logManager = new FetchManager({
  //   batchRequests: true,
  //   fetchTimeout: NODE_ENV === 'development' ? 999_999 : undefined,
  //   logUrl: '/log/graphql',
  //   requestBatchInterval: 1000,
  //   requestBatchMax: 100,
  // });

  return new WorkerClient({
    cache: new WorkerCachemap({
      lazyWorkerInit: true,
      name: 'WORKER_CACHE_GO_BETWEEN',
      type: 'GRAPHQL',
    }),
    debugManager: new DebugManager({
      environment: 'workerClient',
      log: (message: string, data: PlainObject, logLevel?: LogLevel) => {
        if (logLevel === 'error') {
          console.error(message, data);
        }

        // logManager.log(message, data, logLevel);
      },
      name: 'GRAPHQL_BROWSER_WORKER_CLIENT',
      performance: globalThis.performance,
    }),
    lazyWorkerInit: true,
  });
};
